import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import App from './App';
import TrackPageView from './components/TrackPageView';
import AnalyticsWrapper from './components/AnalyticsWrapper';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './index.css'; // Aquí importas Tailwind

AnalyticsWrapper.initialize();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <TrackPageView />
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Registrar el service worker para hacer la app instalable
// Las actualizaciones se aplicarán automáticamente sin notificar al usuario
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('Service Worker registrado exitosamente. La app ahora funciona offline.');
  },
  onUpdate: (registration) => {
    console.log('Nueva versión detectada. Actualizando automáticamente...');
    // Actualización silenciosa: forzar activación inmediata
    const waitingServiceWorker = registration.waiting;
    if (waitingServiceWorker) {
      waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
      // La página se recargará automáticamente cuando el SW se active
    }
  }
});
